import { styles } from '../globals/map-styles';
import { ajaxSpinner } from '../util/ajaxSpinner';

const google = window.google;

export default {
  init() {
  },
  finalize() {
    const urlParams = new URLSearchParams(window.location.search);
    var distance = '';
    var cylch_type = '';
    // var cylch_subtype = '';
    var postcode = '';
    var keyword_search = '';
    var map, directionsRenderer;

    setTimeout(function() {

      if (!$('.distance-select:checked').val()) {
        distance = (urlParams.get('distance')) ? urlParams.get('distance') : '';
        $(`.distance-select[value="${distance}"]`).prop('checked', true);
      } else {
        distance = $('.distance-select:checked').val();
      }

      if (!$('.cylch-type:checked').val()) {
        cylch_type = (urlParams.get('cylch-type')) ? urlParams.get('cylch-type') : '';
        $(`.cylch-type[value="${cylch_type}"]`).prop('checked', true);
      }

      // if (!$('.cylch-subtype:checked').val()) {
      //   cylch_subtype = (urlParams.get('cylch-subtype')) ? urlParams.get('cylch-subtype') : '';
      //   $(`.cylch-subtype[value="${cylch_subtype}"]`).prop('checked', true);
      // }

      if (!$('#cylch-postcode').val()) {
        postcode = (urlParams.get('postcode')) ? urlParams.get('postcode') : '';
        $('#cylch-postcode').val(postcode);
      } else {
        postcode = $('#cylch-postcode').val();
      }

      if (!$('#cylch-keyword').val()) {
        keyword_search = (urlParams.get('keyword-search')) ? urlParams.get('keyword-search') : '';
        $('#cylch-keyword').val(keyword_search);
      } else {
        keyword_search = $('#cylch-keyword').val();
      }

      // Show/hide distance if Postcode empty
      if ($('#cylch-postcode').val().length == 0) {
        $('.filter-group[data-group="distance"]').hide();
      }

    }, 500);

    /**
     * Filters
     */
    $('#search-submit').click(function (event) {
      event.preventDefault();

      postcode = $('#cylch-postcode').val();
      keyword_search = $('#cylch-keyword').val();
      $('.cylch-items-container').empty();

      $('#load-more').data('page', 1);
      load_news(true);
    })

    // Clear filters
    $('#search-clear').on('click', function() {
      $('#cylch-postcode').val('');
      $('#cylch-keyword').val('');
      $('.filter-group[data-group="distance"]').hide();
    });

    /**
     * Load more
     */
    $('#load-more').click(function () {
      $(this).hide();
      load_news();
    });

    function populate_map() {
      $('#cylch-map').empty();

      /**
       * Locations.
       */
      var cylch_types = [];
      $('.type-checkbox').each(function () {
        if (this.checked) {
          cylch_types.push($(this).val());
        }
      })
      
      // var cylch_subtypes = [];
      // $('.subtype-checkbox').each(function () {
      //   if (this.checked) {
      //     cylch_subtypes.push($(this).val());
      //   }
      // })

      cylch_types = cylch_types.join('&');
      // cylch_subtypes = cylch_subtypes.join('&');

      directionsRenderer = new google.maps.DirectionsRenderer();

      map = new google.maps.Map($('#cylch-map').get()[0], {
        styles: styles,
        mapTypeId: google.maps.MapTypeId.HYBDIRD,
      });

      directionsRenderer.setMap(map);

      $.ajax({
        url: '/wp-json/cylch-api/v1/get',
        data: {
          get_all: true,
          keyword: keyword_search,
          types: cylch_types,
          // subtypes: cylch_subtypes,
          distance: distance,
          postcode: postcode,
        },
      })
        .done(function (res) {

          // var cylch_list = [];
          var min_lat = 0;
          var max_lat = 0;
          var min_lng = 0;
          var max_lng = 0;

          var marker_list = [];

          // marker pin image
          const pin_image = {
            url: '/wp-content/themes/meithrin/resources/assets/images/Icons_Pin.svg',
            scaledSize: new google.maps.Size(33, 47),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(16, 47),
          }

          const lang_email = $('#cylch-map').data('lang-email');
          const lang_phone = $('#cylch-map').data('lang-phone');
          const lang_view = $('#cylch-map').data('lang-view');

          var bounds = new google.maps.LatLngBounds();

          res.forEach(function (post) {
            const lang = $('html').attr('lang');
            const post_permalink = post.permalink + '?lang=' + (lang == 'cy-GB' ? 'cy' : 'en');

            const contentString = `
              <div class="cylch-map-content">
                <span class="content-title">${post.post_title}</span>
                <div class="body-content">
                  <p><strong>${lang_email}:</strong> ${post.acf.contact.email_address}</p>
                  <p><strong>${lang_phone}:</strong> ${post.acf.contact.telephone}</p>
                  <p><a href="${post_permalink}">${lang_view}</a></p>
                </div>
              </div>`;

            const infoWindow = new google.maps.InfoWindow({
              content: contentString,
            });

            const marker = new google.maps.Marker({
              position: {
                lat: parseFloat(post.acf.latitude),
                lng: parseFloat(post.acf.longitude),
              },
              map: map,
              title: post.post_title,
              icon: pin_image,
            });

            var pt = new google.maps.LatLng(parseFloat(post.acf.latitude), parseFloat(post.acf.longitude));
            bounds.extend(pt);

            marker.addListener('click', () => {
              // close other marker info windows
              marker_list.forEach((the_marker) => {
                the_marker[1].close();
              });

              infoWindow.open(map, marker);
            });

            marker_list.push([marker, infoWindow]);

            if (min_lat == 0 && min_lng == 0) {
              max_lat = parseFloat(post.acf.latitude);
              min_lat = parseFloat(post.acf.latitude);
              max_lng = parseFloat(post.acf.longitude);
              min_lng = parseFloat(post.acf.longitude);
            } else {

              if (post.acf.latitude >= max_lat) {
                max_lat = parseFloat(post.acf.latitude);
              } else if (post.acf.latitude <= min_lat) {
                min_lat = parseFloat(post.acf.latitude);
              }

              if (post.acf.longitude >= max_lng) {
                max_lng = parseFloat(post.acf.longitude);
              } else if (post.acf.longitude <= min_lng) {
                min_lng = parseFloat(post.acf.longitude);
              }

            }

            // const mid_lat = ((max_lat - min_lat) / 2) + min_lat;
            // const mid_lng = ((max_lng - min_lng) / 2) + min_lng;

            // map.setCenter(new google.maps.LatLng(mid_lat, mid_lng));
            
            // map.setZoom(13);

          //   cylch_list.push({
          //     title: post.post_title,
          //     guid: post.guid,
          //     contact_email_address: post.acf.contact.email_address,
          //     contact_telephone: post.acf.contact.telephone,
          //     address: post.acf.address_one + ' ' + post.acf.address_two + ' ' + post.acf.address_three,
          //   });
          });

          var center = bounds.getCenter();
          map.setCenter(center);
          map.fitBounds(bounds);

        })
        .error(function() {
          console.log('Error retrieving map data. Trying again.');
          populate_map();
        });
    }

    var is_loading = false;
    function load_news(clear_listing) {
      if (is_loading) {
        return;
      }

      is_loading = true;

      /**
       * Locations.
       */


      var cylch_types = [];
      $('.type-checkbox').each(function () {
        if (this.checked) {
          cylch_types.push($(this).val());
        }
      })
      
      // var cylch_subtypes = [];
      // $('.subtype-checkbox').each(function () {
      //   if (this.checked) {
      //     cylch_subtypes.push($(this).val());
      //   }
      // })

      cylch_types = cylch_types.join('&');
      // cylch_subtypes = cylch_subtypes.join('&');

      /**
       * Distance.
       */
      $('.distance-select').on('click', function () {
        var _this = $(this);

        distance = _this.val();
      });

      /**
       * Get current page.
       */
      var current_page = parseInt($('#load-more').data('page'));
      const spinner = new ajaxSpinner($('.cylch-items-holder'));
      
      var lang = $('html').attr('lang');

      populate_map();

      
      var result_entry = '';

      // Only allow one type of search
      if (postcode != '') {
        keyword_search = '';
        result_entry = postcode;
      }

      if (keyword_search != '') {
        postcode = '';
        result_entry = keyword_search;
      }

      $('.cylch-results-entry').html(result_entry);

      $.ajax({
        url: '/wp-json/cylch-api/v1/get',
        data: {
          page: (current_page) ? current_page : 1,
          keyword: keyword_search,
          types: cylch_types,
          // subtypes: cylch_subtypes,
          distance: distance,
          postcode: postcode,
        },
      })
        .done(function (res) {
          // Append posts to page.
          if (clear_listing) {
            $('.cylch-items-container').empty();
          }

          const lang_email = $('#cylch-map').data('lang-email');
          const lang_phone = $('#cylch-map').data('lang-phone');

          var itemsFound = res.length;

          res.forEach(function (post) {

            // console.log(post.subtypes);

            var telephone_el = '';
            if (post.acf.contact.telephone) {
              telephone_el = `<span class="font-weight-400">${lang_phone}</span> ${post.acf.contact.telephone}`;
            }

            var email_el = '';
            if (post.acf.contact.email) {
              email_el = `<span class="font-weight-400">${lang_email}</span> ${post.acf.contact.email}`;
            }

            var list_icon = '';

            if (post.list_icon) {
              list_icon = `<div class="col-2">
                <div class="d-flex w-100 justify-content-end">
                  <div class="card-item-icon" style="background-image: url('${post.list_icon}');"></div>
                </div>
              </div>`;
            }

            var features = {
              breakfastClub: false,
              afterSchoolClub: false,
              thirtyHoursFree: false,
            };

            // if (post.subtypes) {
            //   post.subtypes.forEach((subtype) => {
            //     if (subtype.name == 'After School Club' || subtype.name == 'Lunch Club') {
            //       features.afterSchoolClub = true;
            //     } else if (subtype.name == 'Before School Club') {
            //       features.breakfastClub = true;
            //     } else {
            //       features.thirtyHoursFree = true;
            //     }
            //   });
            // }

            var featuresRendered = '';

            if (features.breakfastClub)
              featuresRendered += '<span class="icon-breakfast-club"></span>';

            if (features.afterSchoolClub)
              featuresRendered += '<span class="icon-after-school-club"></span>';

            if (features.thirtyHoursFree)
              featuresRendered += '<span class="icon-30-hours-free"></span>';

            const post_permalink = post.permalink + '?lang=' + (lang == 'cy-GB' ? 'cy' : 'en');

            var cylchAddress = '';

            if (post.acf.address_one != '') {
              cylchAddress += post.acf.address_one + ', ';
            }

            if (post.acf.address_two != '') {
              cylchAddress += post.acf.address_two + ', ';
            }

            if (post.acf.address_town != '') {
              cylchAddress += post.acf.address_town + ', ';
            }

            if (post.acf.address_three != '') {
              cylchAddress += post.acf.address_three + ', ';
            }

            if (cylchAddress.substring(cylchAddress.length - 2, cylchAddress.length) == ', ') {
              cylchAddress.slice(0, -2);
            }

            var o = `
                <div class="card card-cylch mb-4" data-aos="fade-up" data-aos-duration="400" data-aos-delay="400">
                  <div class="card-body">
                    <div class="row no-gutters">
                      <div class="col-10">
                        <span class="title">${post.post_title}</span>
                        <span class="location">${cylchAddress}</span>
                      </div>
                      ${list_icon}
                    </div>

                    <div class="detail-item">
                      ${telephone_el}
                    </div>
                    <div class="detail-item mb-5">
                      ${email_el}
                    </div>

                    <div class="row">
                      <div class="col-12 col-md-7">
                        <div class="cylch-features h-100 d-flex align-items-center">
                        
                          ${featuresRendered}

                        </div>
                      </div>
                      <div class="col-12 col-md-5">
                        <div class="d-flex w-100 justify-content-end">
                          <a href="${post_permalink}" class="btn btn-primary">${lang == 'cy-GB' ? 'Darllen mwy' : 'Read more'}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
`;

            $('.cylch-items-container').append(o);

            if (res.length !== 5) {
              $('#load-more').fadeOut();
            }
          })

          /**
           * Update page.
           */

          if (itemsFound >= 5) {
            $('#load-more').data('page', current_page + 1);
            $('#load-more').show();
          }

          spinner.remove();

          is_loading = false;
        })
      .error(function () {
        is_loading = false;
        spinner.remove();
        
        // Try again.
        console.log('Error retrieving data. Trying again.');
        load_news(clear_listing);
      })
    }

    // Give everything a quick chance to load 
    setTimeout(function() {
      load_news(); // listing should have more priority
      populate_map();
    }, 700);

    $('#cylch-postcode').on('keydown keyup change', function() {
      if ($(this).val().length == 0) {
        $('.filter-group[data-group="distance"]').hide();
      } else {
        $('.filter-group[data-group="distance"]').show();
      }
    });

    // Switch map/listing view
    $('#view-change-btn').on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();

      if ($(this).data('view-type') == 'listing') {
        $(this).data('view-type', 'map');
        $('.cylch-items-holder').hide();
        $('.cylch-map-container').addClass('map-open');
        $(this).html('List View');
      } else {
        $(this).data('view-type', 'listing');
        $('.cylch-map-container').removeClass('map-open');
        $('.cylch-items-holder').fadeIn(200);
        $(this).html('Map View');
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-cylch-search-listing.js